import { useCallback, useState } from 'react';
import { IIssuer, IIssuerPayload, IIssuerResponse } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IIssuer';
import { getContainer } from '@framework/di/getContainer';
import CreditFlowResearchRepository from '@/creditflowresearch/infrastructure/repository/CreditFlowResearchRepository';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';

export const useArticlesIssuersList = () => {
  const [selected, setSelected] = useState<IIssuer[]>([]);
  const [allowed, setAllowed] = useState<IIssuer[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const container = getContainer();

  const getIssuersList = useCallback(async (payload: IIssuerPayload): Promise<IIssuerResponse> => {
    setIsFetching(true);

    try {
      const creditFlowResearchRepository = container.get<CreditFlowResearchRepository>(CreditFlowResearchRepository);
      const collectionIssuers = await creditFlowResearchRepository.getIssuersList(payload);

      setSelected(collectionIssuers.selected);
      setAllowed(collectionIssuers.allowed);

      return collectionIssuers;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      return { allowed: [], selected: [] };
    } finally {
      setIsFetching(false);
    }
  }, [container]);

  return {
    isFetching,
    selected,
    allowed,
    getIssuersList,
  };
};
